import { Disclaimer } from '@ctw/shared/components/typography/disclaimer';
import { type ClassName, twx } from '@ctw/shared/utils/tailwind';

export interface RiskGapDisclaimerProps {
  className?: ClassName;
}

export const RiskGapDisclaimer = ({ className }: RiskGapDisclaimerProps) => {
  return (
    <Disclaimer className={twx(className)}>
      Zus uses clinical evidence to generate a confidence score and matching diagnosis codes. This
      is not intended to provide a clinical decision. All clinical decisions must be confirmed by a
      licensed healthcare provider.
    </Disclaimer>
  );
};
